type ListItem = {
    [key: string]: any;
}
export const countObjectsWithValue = (
    list: ListItem[],
    targetValue: any
): number => {
    try {
        let counter: number = 0;
        Object.entries(list).map(([i, v], j) => (
            v === targetValue ? counter++ : null
        ))
        return counter;
    } catch (error) {
        return 0
    }
}
